<template>
	<v-container>
		<v-row class="contentRow">
			<v-col>
				<v-alert type="error">The use of this page requires an official Orixe API Key.</v-alert>
				<h1 class="mb-2">Pre-Remove Nodes</h1>
				<p class="mb-10 text-center">
					This is a list of nodes approved to be removed as DUDEs or ANs.
					<br />Add nodes to this list before adding them in a data unit.
					<br />This way, the node will know to approve the data unit once it is submitted.
				</p>
				<v-data-table
					:loading="loading"
					theme--
					light
					:headers="headers"
					:items="nodes"
					:items-per-page="20"
					hide-default-footer
					class="light table"
				>
					<template v-slot:item.remove="{ item }">
						<v-btn color="red" v-on:click="removeRow(item.publicKey)">
							<v-icon color="white" small>fas fa-times</v-icon>
						</v-btn>
					</template>
				</v-data-table>
			</v-col>
			<results-dialog
				:result="result"
				message="The list was successfully updated!"
				:displayServerResult="false"
			/>
			<error-dialog :error="error" />
		</v-row>
		<v-form ref="form" v-model="formIsValid">
			<v-row class="contentRow">
				<v-col cols="12">
					<h2 class="text-center">Add Node to List</h2>
				</v-col>
				<v-col cols="4">
					<v-text-field label="Public Key" :rules="notEmptyRule" v-model="publicKey" outlined></v-text-field>
				</v-col>
				<v-col cols="4">
					<v-select outlined :rules="notEmptyRule" v-model="type" :items="types" label="Type" />
				</v-col>
				<v-col cols="4">
					<v-text-field label="Location" :rules="notEmptyRule" outlined v-model="location" :disabled="this.type=='authorized'"></v-text-field>
				</v-col>
				<v-col cols="12">
					<v-text-field label="API Key" :rules="notEmptyRule" outlined v-model="apikey"></v-text-field>
				</v-col>
				<v-col cols="12">
					<v-btn color="success" :disabled="!formIsValid" v-on:click="addNode" outlined>Add Node</v-btn>
				</v-col>
			</v-row>
		</v-form>
		<v-dialog v-model="isSending" hide-overlay persistent width="300">
			<v-card color="primary" dark>
				<v-card-text>
					<p class="pt-3">Please stand by</p>
					<v-progress-linear indeterminate color="white" class="mb-0 mt-3"></v-progress-linear>
				</v-card-text>
			</v-card>
		</v-dialog>
	</v-container>
</template>


<script>
import API from "../../api/api"
import { getErrorMessage } from "../../utils/errorMessage"

export default {
	name: "PreRemoveNode",

	data() {
		return {
			headers: [
				{ text: "Public Key", value: "publicKey", sortable: false },
				{ text: "Type", value: "type", sortable: true },
				{ text: "Location", value: "location", sortable: false },
				{ text: "Remove", value: "remove", sortable: false }
			],
			nodes: [],
			error: null,
			loading: false,
			isSending: false,
			interval: null,
			result: null,
			type: null,
			publicKey: null,
			location: null,
			apikey: null,
			formIsValid: false,
			types: [
				{ text: "Authorized Node", value: "authorized" },
				{
					text: "DUDE (Data Unit Distribution Executor)",
					value: "dude"
				}
			],
			notEmptyRule: [v => !!v || "This field is required"],
		};
	},
	mounted() {
		this.loadItems();
	},
	methods: {
		loadItems() {
			this.loading = true;
			API
				.get("/api/preremovelist")
				.then(response => {
					this.loading = false;
					if (response.data.error.length > 0) {
						this.error = response.data.error[0].message;
						return;
					}
					this.nodes = [];
					for (let entry of response.data.data) {
						this.nodes.push({
							location: entry.location,
							type: entry.type,
							publicKey: entry.publickey,
							remove: null
						});
					}
				})
				.catch(reason => {
					this.error = getErrorMessage(reason);
					console.log("Load error:", reason);
					this.loading = false;
				});
		},
		addNode: function() {
			this.isAdding = true;
			let postData = {
				type: this.type,
				publickey: this.publicKey,
				location: this.location
			};
			let headers = {
				"X-API-KEY": this.apikey
			};
			API
				.post("/api/preremovelist/", postData, {
					headers: headers
				})
				.then(response => {
					this.isSending = false;
					if (response.data.error.length > 0) {
						this.error = response.data.error[0].message;
						return;
					}
					this.result = response.data;
					this.resetForm();
					this.loadItems();
				})
				.catch(reason => {
					this.error = getErrorMessage(reason);
					this.isSending = false;
				});
		},
		setSendingFalse: function() {
			this.isSending = false;
		},
		resetForm() {
			this.$refs.form.reset();
		},
		removeRow(pubkey) {
			let elements = this.nodes.filter(e => {
				return e.publicKey == pubkey;
			});
			if (elements.length < 1) {
				this.error = "Could not find node in local list.";
				return;
			}
			let element = elements[0];
			//make api call
			let headers = {
				"X-API-KEY": this.apikey
			};
			this.isSending = true;

			API
				.delete("/api/preremovelist/" + pubkey, {
					headers: headers
				})
				.then(response => {
					this.isSending = false;
					if (response.data.error.length > 0) {
						this.error = response.data.error[0].message;
						return;
					}
					this.result =
						"Node was successfully removed from the list.";
					this.resetForm();
					this.nodes.splice(this.nodes.indexOf(element), 1);
				})
				.catch(reason => {
					this.error = getErrorMessage(reason);
					this.isSending = false;
				});
		}
	}
};
</script>